// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Center, Stack, Text } from '@mantine/core';
import { useLingui } from '@lingui/react';
import { useContext, useEffect } from 'react';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import PanePaper from '../../../Molecules/PanePaper';
import BookitupSelect from '../../../Atoms/BookitupSelect';
import { DataS } from '../../../Service/DataS';
import { RoutingS } from '../../../Service/RoutingS';
import LexOfficeConfig from './lox/LexOfficeConfig';
import CandisConfig from './CandisConfig';
import SevdeskConfigPane from './SevdeskConfigPane';
import AccountingEmailPane from './AccountingEmailPane';
import AccountableConfig from './AccountableConfig';
import DatevConfig from './DatevConfig';
import PapierkramConfig from './PapierkramConfig';

const Accounting = () => {
  const { i18n } = useLingui();
  const { profile, patchProfile } = useContext(ProfileContext);

  useEffect(() => {
    RoutingS.changeTitle('Buchhaltung');
  }, []);

  if (!profile) {
    return null;
  }
  const { accountingTool } = profile;

  return (
    <PanePaper sx={{ maxWidth: 1000 }}>
      <Stack mb="xl">
        <Text size="lg" weight="bold">
          {i18n._('accounting.title')}
        </Text>
        <Center>
          <BookitupSelect
            value={accountingTool}
            onChange={(_accountingTool) => _accountingTool && patchProfile({ accountingTool: _accountingTool })}
            data={DataS.getAccountingWebsiteOptions(i18n)}
            sx={{ maxWidth: 200 }}
          />
        </Center>
      </Stack>

      {accountingTool === 'LexOffice' && <LexOfficeConfig />}
      {accountingTool === 'Candis' && <CandisConfig />}
      {accountingTool === 'sevDesk' && <SevdeskConfigPane />}
      {accountingTool === 'Accountable' && <AccountableConfig />}
      {accountingTool === 'Papierkram' && <PapierkramConfig />}
      {accountingTool === 'DATEV' && <DatevConfig />}
      {accountingTool === 'E-Mail' && <AccountingEmailPane />}
      {accountingTool === 'Other' && (
        <Text>Schreib uns gerne, welches Tool du benutzt und wir prüfen, ob wir es an bookitup anbinden können.</Text>
      )}
    </PanePaper>
  );
};

export default Accounting;
